import { useFeatureFlag } from '../../../hooks/useFeatureFlag';

export const useIsRachelAvailable = (): boolean => {
  const { isEnableRachelChat } = useFeatureFlag();

  return isEnableRachelChat;
};
